<template>
  <div :class="['side-nav', isHiddenByDefault() ? 'default-hide' : '']">
    <div class="action-icons" v-if="authUser && !helpMenu">
      <rp-sprite @click.native="toggleMenu" name="more_vert"></rp-sprite>
      <rp-sprite @click.native="closeNav" name="close" :class="[isHiddenByDefault() ? '' : 'burger']"></rp-sprite>
    </div>
    <rp-help-menu v-if="authUser && helpMenu" @toggleHelpMenu="toggleMenu"/>
    <!--<div class="eye-image"></div>-->
    <div class="nav-items">
      <users-links />
      <messages-links />
      <rp-permissions :requireAll="['read_patients', 'write_patients']">
      <operations-links />
      </rp-permissions>
      <rp-permissions :requireAll="['read_patients', 'write_patients']">
      <patients-links />
      </rp-permissions>
      <settings-links />
      <surgeons-links />
      <dashboard-links v-if="getIsAuthenticated" />
      <unauthenticated-links />
      <hospitals-links />
      <clinical-links />
    </div>
  </div>
</template>

<script>
  import RpSprite from 'raypro_ui/src/components/ui/Sprite'
  import Permissions from 'raypro_ui/src/components/Permissions'
  import helpMenu from '../HelpMenu'

  import UsersLinks from './UsersLinks'
  import MessagesLinks from './MessagesLinks'
  import PatientsLinks from './PatientsLinks'
  import SettingsLinks from './SettingsLinks'
  import SurgeonsLinks from './SurgeonsLinks'
  import DashboardLinks from './DashboardLinks'
  import OperationsLinks from './OperationsLinks'
  import UnauthenticatedLinks from './UnauthenticatedLinks'
  import HospitalsLinks from './HospitalsLinks'
  import ClinicalLinks from './ClinicalLinks'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      'rp-sprite': RpSprite,
      'rp-permissions': Permissions,
      'rp-help-menu': helpMenu,
      UsersLinks,
      MessagesLinks,
      PatientsLinks,
      SettingsLinks,
      SurgeonsLinks,
      DashboardLinks,
      OperationsLinks,
      UnauthenticatedLinks,
      HospitalsLinks,
      ClinicalLinks
    },

    data() {
      return {helpMenu: false}
    },

    computed: {...mapGetters(['getIsAuthenticated', 'authUser'])},

    methods: {
      toggleMenu() {
        this.helpMenu = !this.helpMenu
      },
      closeNav() {
        this.$emit('closeNav')
      },
      isHiddenByDefault() {
        // Hide by default on login and dashboard pages
        return this.$route.path.startsWith('/dashboard') ||
          this.$route.path.startsWith('/login') ||
          this.$route.path.startsWith('/registration') ||
          this.$route.path.startsWith('/reset_password_email') ||
          this.$route.path.startsWith('/patients/add-patients') ||
          this.$route.path.startsWith('/patients/add-patient-preop') ||
          this.$route.path.startsWith('/patients/patient-consent')
      },
    }
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import '../../stylesheets/helpers/mixins'

  .side-nav
    min-height: calc(100vh - 75px)
    min-width: $side-nav-width
    //background: $color-side-nav
    //border-right: 1px inset $color-grey
    position: absolute
    transform: translateX(-100%)
    transition: transform .4s ease-in-out
    z-index: 5

    .action-icons
      //background-color: $color-primary
      position: absolute
      //display: flex
      justify-content: space-between
      align-items: center
      width: 100%
      z-index: 999
      padding: 14px 6px
      .sprite
        cursor: pointer
        width: 20px
        height: 20px
        margin: 0 3px
        fill: $color-panel-bg
        &.burger
          @include media($media-medium)
            display: none

    .page-patient-questionnaire &
      display: none

    .nav-items
      opacity: 0
      transition: opacity .4s ease-in-out
      margin-top: 60px

    @include media($media-medium)
      // position: relative
      flex-basis: 30%
      max-width: 250px
      transform: none
      position: sticky
      top: 75px
      height: calc(100vh - 75px)

      .nav-items
        opacity: 1

    .sidebar-links
      position: relative

      a
        display: block
        padding: 15px 10px
        border-left: 3px solid transparent
        color: $color-panel-bg
        line-height: 1.2
        font-size: 14px
        font-weight: $font-light
        cursor: pointer

        &.active
          border-color: $color-panel-bg
          background-color: darken($color-side-nav, 10)

    // .router-link-exact-active
    //   border-color: $color-panel-bg
    //   background-color: darken($color-side-nav, 10)

    &.default-hide
      position: absolute
      opacity: 0
      pointer-events: none
      transform: translate(-100%)

  .eye-image
    background: url('../../assets/eye-image.png')
    background-size: cover
    background-position: 50% 50%
    position: absolute
    top: 0
    width: 100%
    height: 200px

</style>



// WEBPACK FOOTER //
// src/components/SideNav/SideNav.vue